import DonatePageSections from "features/DonatePage"

const DonatePage = () => {
  return (
    <DonatePageSections />
  )
}

export default DonatePage